(function(){
  'use strict';

  if (window.__ERECTUS_SEAL_DEFAULT_SCRIPT__) return;
  window.__ERECTUS_SEAL_DEFAULT_SCRIPT__ = true;

  var applied = false;
  var userTouched = false;

  function isProductPage(){
    return /^\/products\//.test(window.location.pathname || '') ||
      !!(document.body && document.body.classList.contains('template-product'));
  }

  function getSeal(){
    return document.querySelector('.sealsubs-target-element.sls-homepage-automatic.sealsubs-full') ||
      document.querySelector('.sealsubs-target-element');
  }

  function getRecurringRadio(seal){
    if (!seal) return null;
    return seal.querySelector('input.sls-option[name^="subs_type_"][data-type="subscription"]') ||
      seal.querySelector('input.sls-option[data-type="subscription"]');
  }

  function markUserTouch(event){
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('.sealsubs-target-element')) userTouched = true;
  }

  function applyDefault(){
    if (applied || userTouched || !isProductPage()) return applied;
    var seal = getSeal();
    var recurring = getRecurringRadio(seal);
    if (!recurring || recurring.disabled) return false;

    applied = true;
    window.__ERECTUS_SEAL_DEFAULT_APPLIED__ = true;

    if (!recurring.checked) {
      recurring.click();
    } else {
      recurring.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function start(){
    if (!isProductPage()) return;

    document.addEventListener('pointerdown', markUserTouch, true);
    document.addEventListener('keydown', markUserTouch, true);

    var tries = 0;
    var timer = window.setInterval(function(){
      tries += 1;
      if (applyDefault() || userTouched || tries >= 40) {
        window.clearInterval(timer);
      }
    }, 250);

    var observer = new MutationObserver(function(){
      if (applied || userTouched) {
        observer.disconnect();
        return;
      }
      if (getRecurringRadio(getSeal())) {
        window.setTimeout(function(){
          if (applyDefault()) observer.disconnect();
        }, 300);
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function(){ observer.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
